var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-links-component" }, [
    _c("div", { staticClass: "text__center margin-b__20 modal-header" }, [
      _c(
        "a",
        {
          staticClass: "arrow-back arrow-back__extra",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("@assets/imgs/arrow-back.svg"),
              alt: "Back Arrow"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("b", [_vm._v("Add links")])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "add-links-body" },
      [
        _c(
          "div",
          {
            staticClass: "add-links-form",
            class: { "has-img": _vm.attachURLImage }
          },
          [
            _vm.attachURLImage
              ? _c("CoverImg", { attrs: { src: _vm.attachURLImage } })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.attachURL,
                  expression: "attachURL"
                }
              ],
              staticClass: "full__width",
              attrs: { type: "text", placeholder: "Type or paste url here" },
              domProps: { value: _vm.attachURL },
              on: {
                blur: _vm.getInfoFromUrl,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.attachURL = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.attachURL
              ? _c(
                  "button",
                  {
                    staticClass: "btn__reset",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.addLink($event)
                      }
                    }
                  },
                  [
                    _vm.parsingProgress &&
                    _vm.awaitParsingForAdd &&
                    !_vm.awaitParsingForSave
                      ? _c("i", { staticClass: "spinner-border" })
                      : _c("i", { staticClass: "icon-add color__secondary_60" })
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("ParsedLinks", {
          attrs: { links: _vm.links, editable: true },
          on: { deleteLink: _vm.deleteLink }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer text__right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn__m btn__round btn__bordered",
          attrs: { disabled: _vm.attachURLDisabled },
          on: {
            click: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.saveLinksToPost($event)
            }
          }
        },
        [
          _vm._v("\n            Add\n            "),
          _vm.parsingProgress && _vm.awaitParsingForSave
            ? _c("i", { staticClass: "spinner-border" })
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }